<div class="row">
        <div class="container-fluid">
    <div class="card" style="margin:5% auto; width: 50%;">
      <div class="card-data">
          <h1 class="text-center">
              <span class="fa-stack fa-1x">
                  <i class="fa fa-circle fa-stack-2x text-primary"></i>
                  <i class="fa fa-user fa-stack-1x fa-inverse"></i>
              </span>Forgot Password?
      </h1>
      <div class="form-group col-md-12">
          <label>Username</label>
          <input type="text" [(ngModel)]="loginUser.Username" class="form-control input-sm" required />
        </div>
      
      <div class="form-group col-md-12">
        <label>Email Address</label>
        <input type="text" [(ngModel)]="loginUser.EmailAddress" class="form-control input-sm" required />
      </div>
      <div class="row">
      <div class="form-group col-md-6">
          <button class="btn btn-sm btn-primary" (click)="sendPassword()"><i class="fa fa-save" style="margin-right:5px;"></i>Continue</button>
      </div>
      <div class="form-group col-md-6">
          <button class="btn btn-sm btn-default pull-right" routerLink="/home"><i class="fa fa-undo" style="margin-right:5px"></i>Cancel</button>
        </div>
      </div>
         
      </div>
    </div>
  
  </div>